module.exports = __webpack_public_path__ + "img/logo-hei.497c7aba.png";